import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { adminActions } from 'store/admin/slices';

export const useGetDumps = (): void => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(adminActions.dumps.requestFolders());
  }, []);
};
